import { pipe } from 'fp-ts/function';
import * as R from 'fp-ts/ReadonlyRecord';
export function fieldIsNonNullable(key) {
  return function (x) {
    return x[key] != null;
  };
}

/* eslint-disable
   @typescript-eslint/no-unsafe-return,
   @typescript-eslint/no-explicit-any,
   @typescript-eslint/no-unsafe-argument
 */
export var partialEvolve = function partialEvolve(f) {
  return R.mapWithIndex(function (k, r) {
    var fk = f[k];
    return fk ? fk(r) : r;
  });
};
/* eslint-enable */

export var prop = function prop(_prop) {
  return function (rec) {
    return rec[_prop];
  };
};
export var makeWith = function makeWith(r) {
  return function (a) {
    return pipe(r, R.map(function (f) {
      return f(a);
    }));
  };
};